export default __webpack_public_path__ + "static/media/topcharacter1.2d22f015.jpeg";